import React, { useState } from 'react';
import { CATEGORIES } from './registry/MetricRegistry';
import { useDashboardPrefs } from './hooks/useDashboardPrefs';
import DashboardHome from './DashboardHome';
import CategoryView from './CategoryView';

const CATEGORY_LABELS = {
  'users': 'Users',
  'assessment': 'Assessment',
  'employer-funnel': 'Employer Funnel',
  'candidate-funnel': 'Candidate Funnel',
  'marketplace': 'Marketplace',
  'revenue': 'Revenue',
  'cohorts': 'Cohorts',
  'operational': 'Operational',
};

const TABS = [
  { id: 'home', label: 'Home' },
  ...CATEGORIES.map((c) => ({ id: c, label: CATEGORY_LABELS[c] || c })),
];

const DashboardContainer = () => {
  const [activeTab, setActiveTab] = useState('home');
  const {
    pinnedCards,
    setPinnedCards,
    appliedPreset,
    setAppliedPreset,
    resetToDefaults,
    loaded,
  } = useDashboardPrefs();

  const handleTogglePin = (metricId) => {
    if (pinnedCards.includes(metricId)) {
      setPinnedCards(pinnedCards.filter((id) => id !== metricId));
    } else {
      setPinnedCards([...pinnedCards, metricId]);
    }
  };

  const handleApplyPreset = (presetId, metricIds) => {
    if (metricIds) {
      setAppliedPreset(presetId, metricIds);
    } else {
      // "Custom" selected — clear preset label, keep current pins
      setAppliedPreset(presetId, pinnedCards);
    }
  };

  return (
    <div className="p-6 bg-bluegray text-lightgray">
      <h2 className="text-2xl font-bold text-orange mb-4">Analytics Dashboard</h2>
      {/* Tab strip */}
      <div className="flex flex-wrap gap-2 mb-6" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            role="tab"
            aria-selected={activeTab === tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2 rounded text-sm font-medium transition-colors ${
              activeTab === tab.id
                ? 'bg-orange text-white'
                : 'text-lightgray hover:bg-deepblue'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {/* Active view */}
      {activeTab === 'home' && (
        <DashboardHome
          pinnedCards={pinnedCards}
          onTogglePin={handleTogglePin}
          appliedPreset={appliedPreset}
          onApplyPreset={handleApplyPreset}
          onReset={resetToDefaults}
          loaded={loaded}
        />
      )}
      {activeTab !== 'home' && (
        <CategoryView
          category={activeTab}
          pinnedCards={pinnedCards}
          onTogglePin={handleTogglePin}
        />
      )}
    </div>
  );
};

export default DashboardContainer;
